<template>
  <div class="overlay" @click="close">
    <div class="overlay-content">
      <component :is="content.key" :name="content.name"></component>
    </div>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  data () {
    return {
      state: {
        show: false,
        content: ``,
      }
    }
  },

  methods: {
    close: function (e) {
      if (e.target.classList.contains("overlay")) {
        this.$emit("close");
      }
    }
  },

  props: ["content"],

  watch: {
    content: function () {
      console.log("content", this)
    }
  },

  components: {
  },
};
</script>

<style scoped>
.overlay {
  width: 100vw;
  height: 100vh;
  background: #263e52d0;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  opacity: 0;

  z-index: 10000;
  transition: all 0.3s ease;

  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay.show {
  pointer-events: all;
  opacity: 1;
}

.overlay-content {
  background: #fff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/generics/Overlay.vue